import { TKUITheme, black, white } from "tripkit-react/dist/jss/TKUITheme";

const confirmSignInFormJss = (theme: TKUITheme) => ({
    description: {
        fontSize: '1.125rem',
        lineHeight: '1.5rem',
        padding: '20px',
        textAlign: 'center'
    },
    codeInput: {
        fontSize: '1.5rem',
        letterSpacing: '0.5rem',
        width: '100%',
        padding: '15px calc(50% - 65px)',
        border: '1px solid ' + black(2, theme.isDark),
        borderRadius: '8px',
        display: 'flex',
        justifyContent: 'center',
        background: white(0, theme.isDark),
        ...theme.textColorDefault
    },
    rememberDevice: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px 0'
    },
    toggle: {
        width: '50px',
        height: '28px',
        cursor: 'pointer'
    },
    iconLoading: {
        width: '30px!important',
        height: '18px!important',
        margin: '3px 0',
        '& path': {
            fill: white()
        }
    },
    errorMessage: {
        color: theme.colorError,
        height: 0,
        margin: '-10px 0 35px!important',
        textAlign: 'center'
    }
});

export default confirmSignInFormJss;
